import { Directive, Input, ViewContainerRef, ComponentFactoryResolver, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormTextareaComponent } from '../form-textarea/form-textarea.component';
import { FormInputComponent } from '../form-input/form-input.component';
import { FormSelectComponent } from '../form-select/form-select.component';
import { FormCheckboxComponent } from '../form-checkbox/form-checkbox.component';
import { FormRadioComponent } from '../form-radio/form-radio.component';
import { FormFileComponent } from '../form-file/form-file.component';
import { FormTermsComponent } from '../form-terms/form-terms.component';
import { FormInfoMessageComponent } from '../form-info-message/form-info-message.component';

const components = {
    textarea: FormTextareaComponent,
    input: FormInputComponent,
    select: FormSelectComponent,
    checkbox: FormCheckboxComponent,
    radio: FormRadioComponent,
    file: FormFileComponent,
    terms: FormTermsComponent,
    infoMessage: FormInfoMessageComponent
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[dynamicField]',
})
export class DynamicFieldDirective implements OnInit {
    @Input() config;

    @Input() group: FormGroup;

    component;

    constructor(
        private resolver: ComponentFactoryResolver,
        private container: ViewContainerRef
    ) {}

    ngOnInit() {
        const component = components[this.config.type];
        const factory = this.resolver.resolveComponentFactory<any>(component);
        this.component = this.container.createComponent(factory);
        this.component.instance.config = this.config;
        this.component.instance.group = this.group;
    }
}
